import axios from '@/common/axios'
import qs from 'qs'

export function getVisitorRecord (data) {
  return axios({
    method: 'get',
    url: '/visitRegistration/recordList',
    params: data
  })
}
